/* eslint-disable no-magic-numbers */
import SkillzStyle from 'SkillzStyle';

import {
  StyleSheet,
} from 'react-native';

const {
  fontBold,
  fontSizeH4,
  fontSizeH5,
  textColorPrimary,
  viewPrimaryColor,
  tabHighlightColor,
} = SkillzStyle.fullStyles;

export const CELL_HEIGHT = 108;
export const ARROW_WIDTH = 12;
export const ARROW_HEIGHT = 12;

export default StyleSheet.create({
  expandedCellContainer: {
    flex: 1,
    marginTop: 5,
    marginBottom: 12,
  },

  expandedArrowContainer: {
    height: ARROW_HEIGHT,
    flexDirection: 'row',
  },

  expandedCell: {
    backgroundColor: SkillzStyle.convertToOpacity(viewPrimaryColor.backgroundColor, .8),
    overflow: 'hidden',
  },

  expandedCellContent: {
    flex: 1,
    flexDirection: 'column',
    padding: 20,
  },

  expandedArrow: {
    width: 0,
    height: 0,
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderLeftWidth: 6,
    borderRightWidth: 6,
    borderBottomWidth: 12,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: SkillzStyle.convertToOpacity(viewPrimaryColor.backgroundColor, .8),
    alignSelf: 'center',
  },

  nextExpText: {
    ...textColorPrimary,
    ...fontBold,
    ...fontSizeH4,
  },

  totalExpText: {
    ...textColorPrimary,
    ...fontBold,
    ...fontSizeH5,
  },

  progressBarContainer: {
    height: 8,
    alignSelf: 'stretch',
    flexDirection: 'row',
    marginTop: 8,
    marginBottom: 20,
    borderWidth: 1,
    borderColor: SkillzStyle.convertToOpacity(textColorPrimary.color, .5),
    ...viewPrimaryColor,
  },

  progressBarFill: {
    backgroundColor: tabHighlightColor.color,
  },
});
